import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom/dist";
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { Select, Spin, Drawer, DatePicker } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import dayjs from "dayjs";
import "jspdf-autotable";
import {
  //   ChevronUp,
  RotateCcw,
  Edit,
  Eye,
  Filter,
  Search,
} from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import ViewCTC from "./ViewCTC";
import EditCTC from "./EditCTC";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faGear, faHeartbeat } from "@fortawesome/free-solid-svg-icons";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";
import Swal from "sweetalert2";

const Employee_Anual_CTC = () => {
  const [dataLoading, setDataLoading] = useState(false);
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [viewObj, setViewObj] = useState([]);
  const [editObj, setEditObj] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [branchesList, setBranchesList] = useState([]);
  const [DeptList, setDeptList] = useState([]);
  const [SalaryGroupList, setSalaryGroupList] = useState([]);
  // Table filters
  const [tableBranchId, setTableBranchId] = useState(0);
  const [tableDeptId, setTableDeptId] = useState(0);
  const [tableEmpId, setTableEmpId] = useState([0]);
  const [tableFilteredEmployees, setTableFilteredEmployees] = useState([]);

  // Add expense form (offcanvas)
  const [addBranchId, setAddBranchId] = useState(null);
  const [addDeptId, setAddDeptId] = useState(null);
  const [addEmployeeId, setAddEmployeeId] = useState(null);
  const [addFilteredEmployees, setAddFilteredEmployees] = useState([]);
  const [effectiveDate, setEffectiveDate] = useState(null);
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [monthlyCTC, setMonthlyCTC] = useState("");
  const [selectedSalaryGroup, setSelectedSalaryGroup] = useState(null);
  const [loadingSave, setLoadingSave] = useState(false);
  const [empData, setEmpData] = useState([]);
  //   const navigate = useNavigate();
  const renderStatusIcons = (record) => {
    if (!record) return null;

    const isPF = record.IsPFEnabled === 1;
    const isESI = record.IsESIEnabled === 1;

    return (
      <>
        <FontAwesomeIcon
          icon={faGear}
          title={isPF ? "PF Enabled" : "PF Disabled"}
          className={isPF ? "text-primary" : "text-muted"}
        />

        <FontAwesomeIcon
          icon={isESI ? faHeartbeat : faBan}
          title={isESI ? "ESI Enabled" : "ESI Disabled"}
          className={isESI ? "text-success" : "text-danger"}
        />
      </>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const addEmpOptions = addFilteredEmployees.map((emp) => ({
    label: emp.UserName,
    value: emp.RegId,
  }));

  const BranchesOptions = [
    { label: "All Branches", value: 0 },
    ...branchesList.map((branch) => ({
      label: branch.Name,
      value: branch.branchid,
    })),
  ];
  const addBranchesOptions = [
    ...branchesList.map((branch) => ({
      label: branch.Name,
      value: branch.branchid,
    })),
  ];

  const DeptOptions = [
    { label: "All Dept", value: 0 },
    ...DeptList.map((Dept) => ({
      label: Dept.Name,
      value: Dept.DepartmentId,
    })),
  ];
  const addDeptOptions = [
    ...DeptList.map((Dept) => ({
      label: Dept.Name,
      value: Dept.DepartmentId,
    })),
  ];
  const addSalaryGroupOptions = [
    ...SalaryGroupList.map((salaryGroup) => ({
      label: salaryGroup.Name,
      value: salaryGroup.Id,
    })),
  ];

  // const PayperiodOptions = PayPeriodlist.map(period => ({
  //   label: period.Name,
  //   value: period.PayPeriodId,
  //   data: period,
  // }));

  const columns = [
    {
      title: "Badge",
      dataIndex: "Badge",
      sorter: (a, b) => a.Badge.localeCompare(b.Badge),
    },
    {
      title: "Employee",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName.localeCompare(b.UserName),
      render: (text) => (
        <span title={text}>
          {text?.length > 20 ? `${text.substring(0, 20)}...` : text}
        </span>
      ),
    },
    {
      title: "Monthly",
      dataIndex: "MonthlyCTC",
      sorter: (a, b) => a.monthlySalary - b.monthlySalary,
      render: (text) => `₹${text?.toLocaleString() || "N/A"}`,
    },
    {
      title: "Yearly",
      dataIndex: "AnnualCTC",
      sorter: (a, b) => a.yearlyCTC - b.yearlyCTC,
      render: (text) => `₹${text?.toLocaleString() || "N/A"}`,
    },

    {
      title: "Revised On",
      sorter: (a, b) => {
        if (!a.EffectiveDate || !b.EffectiveDate) return 0;
        return new Date(a.EffectiveDate) - new Date(b.EffectiveDate);
      },
      render: (_, record) => {
        const { EffectiveDate, EndDate } = record;

        if (!EffectiveDate) return "-";
        return (
          <div>
            <div>{formatDate(EffectiveDate)}</div>
            <small className="text-muted">
              To {EndDate ? formatDate(EndDate) : "Present"}
            </small>
          </div>
        );
      },
    }
    ,
    {
      title: "Status",
      dataIndex: "IsPFEnabled",
      sorter: (a, b) =>
        (a.IsPFEnabled + a.IsESIEnabled) -
        (b.IsPFEnabled + b.IsESIEnabled),

      render: (_, record) => (
        <div className="d-flex gap-2">
          {renderStatusIcons(record)}
        </div>
      ),
    },

    {
      title: "Action",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          <Link
            to="#"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRightViewCTC"
            aria-controls="#offcanvasRightViewCTC"
            className="dropdown-item d-flex align-items-center"
            onClick={() => setViewObj(record)}
          >
            <Eye className="info-img" />
          </Link>
          <Link
            to="edit-sales.html"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRightEditCTC"
            aria-controls="#offcanvasRightEditCTC"
            className="dropdown-item d-flex align-items-center"
            onClick={() => setEditObj(record)}
          >
            <Edit
              className="info-img text-info"
              style={{ marginLeft: "-8px" }}
            />
          </Link>
        </div>
      ),
    },
  ];
  const handleReload = () => {
    window.location.reload();
  };

  const handleDownloadExcel = () => {
    if (empData.length === 0) return;

    const wb = XLSX.utils.book_new();
    const wsData = empData.map((item, index) => ({
      "S.No": index + 1,
      Employee: item.employee,
      "Emp Code": item.empCode,
      "Monthly Salary": item.monthlySalary,
      "Yearly CTC": item.yearlyCTC,
      Group: item.group,
      "Start Date": formatDate(item.startDate),
      "End Date": formatDate(item.endDate),
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Annual CTC");
    XLSX.writeFile(wb, "Employee_Annual_CTC.xlsx");
  };

  const generatePDF = () => {
    if (empData.length === 0) return;

    const doc = new jsPDF();
    doc.text("Employee Annual CTC Report", 14, 10);

    const tableColumn = [
      "S.No",
      "Employee",
      "Emp Code",
      "Monthly Salary",
      "Yearly CTC",
      "Group",
      "Start Date",
      "End Date",
    ];
    const tableRows = empData.map((item, index) => [
      index + 1,
      item.employee,
      item.empCode,
      `$${item.monthlySalary.toLocaleString()}`,
      `$${item.yearlyCTC.toLocaleString()}`,
      `$${item.group.toLocaleString()}`,
      formatDate(item.startDate),
      formatDate(item.endDate),
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows, startY: 20 });
    doc.save("Employee_Annual_CTC.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      PDF
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    // const superId = sessionStorage.getItem("superId");
    const superId = sessionStorage.getItem("PayrollSuperId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchBranchsList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Branches");
          }

          const data = await response.json();

          if (data.status) {
            setBranchesList(data.ResultData);
          } else {
            console.error("Invalid Branches response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching BranchesList:", error.message);
        }
      };
      fetchBranchsList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchDeptList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Dept");
          }

          const data = await response.json();

          if (data.status) {
            setDeptList(data.ResultData);
          } else {
            console.error("Invalid Dept response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching DeptList:", error.message);
        }
      };
      fetchDeptList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchSalaryGrupList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}payroll/EmployeCTC/getSalaryGroupMaster?SuperId=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Dept");
          }

          const data = await response.json();

          if (data.status) {
            setSalaryGroupList(data.ResultData);
          } else {
            console.error("Invalid Dept response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching DeptList:", error.message);
        }
      };
      fetchSalaryGrupList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (!superIdData) return;

    const fetchTableEmployees = async () => {
      try {
        const branchId = showAdvancedSearch ? tableBranchId : 0;
        const deptId = showAdvancedSearch ? tableDeptId : 0;

        if (showAdvancedSearch && (!branchId || !deptId)) {
          setTableFilteredEmployees([]);
          return;
        }

        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/payroll/getemployees?superid=${superIdData}&BranchId=${branchId}&DeptId=${deptId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
          }
        );

        const data = await response.json();
        setTableFilteredEmployees(data.status ? data.ResultData : []);
      } catch (error) {
        console.error("Employee fetch error:", error);
        setTableFilteredEmployees([]);
      }
    };

    fetchTableEmployees();
  }, [
    superIdData,
    showAdvancedSearch,
    tableBranchId,
    tableDeptId,
  ]);

  useEffect(() => {
    if (!superIdData) return;

    const fetchAddEmployees = async () => {
      try {
        const response = await fetch(
          `${Payroll_API_BASE_URL}payroll/EmployeCTC/getNewEmpListForctcadd?superid=${superIdData}&BranchId=${addBranchId || 0}&DeptId=${addDeptId || 0}`,
          // `${Payroll_API_BASE_URL}payroll/payroll/getemployees?superid=${superIdData}&BranchId=${addBranchId || 0}&DeptId=${addDeptId || 0}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
            },
          }
        );

        const data = await response.json();
        setAddFilteredEmployees(data.status ? data.ResultData : []);
      } catch {
        setAddFilteredEmployees([]);
      }
    };

    if (addBranchId && addDeptId) {
      fetchAddEmployees();
    } else {
      setAddFilteredEmployees([]);
    }
  }, [superIdData, addBranchId, addDeptId]);

  // useEffect(() => {
  //   if (tokenData && superIdData) {
  //     const fetchPayPeriodsList = async () => {
  //       setDataLoading(true);
  //       setPayPeriodlist([]); // reset old data

  //       try {
  //         const response = await fetch(
  //           `${Payroll_API_BASE_URL}payroll/Process/getPayPeriod?SuperId=${superIdData}&BranchId=0`,
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
  //             },
  //           }
  //         );

  //         if (!response.ok) {
  //           throw new Error("Failed to fetch Pay Periods");
  //         }

  //         const data = await response.json();

  //         if (data.status) {
  //           setPayPeriodlist(data.ResultData);
  //         } else {
  //           setPayPeriodlist([]);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching PayPeriodList:", error.message);
  //         setPayPeriodlist([]);
  //       } finally {
  //         setDataLoading(false);
  //       }
  //     };

  //     fetchPayPeriodsList();
  //   }
  // }, [superIdData, tokenData]);

  const fetchEmployeeData = async () => {
    setDataLoading(true);
    try {
      const params = new URLSearchParams({
        SuperId: superIdData,
        EmployeeId: tableEmpId || 0,
        BranchId: tableBranchId || 0,
        DeptId: tableDeptId || 0,
      });

      const response = await fetch(
        `${Payroll_API_BASE_URL}payroll/payroll/getctcreport?${params.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch CTC report");

      const data = await response.json();

      if (data.status) {
        setEmpData(data.ResultData || []);
      } else {
        console.error("API returned error:", data.ErrorMsg);
        setEmpData([]);
      }
    } catch (error) {
      console.error("Error fetching CTC report:", error);
      setEmpData([]);
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    if (!tokenData || !superIdData) return;
    fetchEmployeeData();
  }, [tableEmpId, tableDeptId, tableDeptId, tokenData, superIdData]);

  const handleSaveCTC = async () => {
    if (
      !addEmployeeId ||
      !effectiveDate ||
      !monthlyCTC ||
      isNaN(monthlyCTC)
    ) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please fill all required fields",
        confirmButtonText: "OK",
      });
      return;
    }

    setLoadingSave(true);

    try {
      const payload = {
        SuperId: Number(superIdData),
        RegId: Number(addEmployeeId),
        MonthlyCTC: Number(monthlyCTC),
        SalaryGroupMasterId: selectedSalaryGroup,
        CreatedBy: Number(superIdData),
        EffectiveDate: effectiveDate.format("YYYY-MM-DD"),
      };

      const response = await fetch(
        `${Payroll_API_BASE_URL}payroll/EmployeCTC/addEmpCtc`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (response.ok && data?.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Employee CTC added successfully",
          confirmButtonText: "OK",
        }).then(() => {
          setAddEmployeeId(null);
          setMonthlyCTC("");
          setEffectiveDate(null);
          setAddBranchId(null);
          setAddDeptId(null);
          setDrawerOpen(false);
          fetchEmployeeData();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data?.ErrorMsg || "Unable to add Employee CTC",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Save CTC error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while saving",
        confirmButtonText: "OK",
      });
    } finally {
      setLoadingSave(false);
    }
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header m-1">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      {/* Employee Annual CTC */}
                      Employee Salary Details
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your Employee Salary Details here</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={generatePDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="PDF"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link onClick={handleDownloadExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="Excel"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-success"
                  onClick={(e) => {
                    e.preventDefault();
                    setDrawerOpen(true);
                  }}
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 p-1">
              <div className="search-set">
              </div>
              <div className="d-flex right-content align-items-end">
                {/* Branch & Dept (Advanced Search Only) */}
                {showAdvancedSearch && (
                  <>
                    <div className="dropdown me-2 pt-3">
                      <div className="input-blocks">
                        <i data-feather="check-circle" className="info-img" />
                        <Select
                          showSearch
                          placeholder="Select Branch"
                          value={tableBranchId}
                          onChange={(val) => setTableBranchId(val)}
                          options={BranchesOptions}
                          style={{ width: 170, height: 37 }}
                          optionFilterProp="label"
                        />
                      </div>
                    </div>

                    <div className="dropdown me-2 pt-3">
                      <div className="input-blocks">
                        <i data-feather="check-circle" className="info-img" />
                        <Select
                          showSearch
                          placeholder="Select Dept"
                          value={tableDeptId}
                          onChange={(val) => setTableDeptId(val)}
                          options={DeptOptions}
                          style={{ width: 170, height: 37 }}
                          optionFilterProp="label"
                        />
                      </div>
                    </div>
                  </>
                )}

                {/* Employee Dropdown (Always Visible) */}
                <div className="dropdown me-2 pt-3">
                  <div className="input-blocks">
                    <i data-feather="check-circle" className="info-img" />
                    <Select
                      showSearch
                      placeholder="Select Employee"
                      value={tableEmpId}
                      onChange={(val) => setTableEmpId(val)}
                      options={[
                        { label: "All Employees", value: 0 },
                        ...tableFilteredEmployees.map((emp) => ({
                          label: emp.UserWithBadge,
                          value: emp.RegId,
                        })),
                      ]}
                      style={{ width: 200, height: 37 }}
                      optionFilterProp="label"
                      virtual={false}
                    />
                  </div>
                </div>
                <div className="dropdown me-2 pt-3">
                  <div className="input-blocks">
                    <button
                      type="button"
                      className={`btn btn-outline-primary d-flex align-items-center justify-content-center ${showAdvancedSearch ? "active" : ""
                        }`}
                      onClick={() => {
                        setShowAdvancedSearch((prev) => !prev);
                        setTableBranchId(0);
                        setTableDeptId(0);
                        setTableEmpId(0);
                      }}
                      title={showAdvancedSearch ? "Close Advanced Search" : " Open Advanced Search"}
                      style={{ width: 38, height: 38 }}
                    >
                      {showAdvancedSearch ? (
                        <Search
                          size={26}
                          style={{ transform: "scale(1.7)" }}
                        />
                      ) : (
                        <Filter
                          size={26}
                          style={{ transform: "scale(1.7)" }}
                        />
                      )}
                    </button>

                  </div>
                </div>


              </div>



            </div>
            <div className="card-body">
              <div className="table-responsive brand-table">
                {dataLoading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <Table columns={columns} dataSource={empData} rowKey="Badge" pgno={true} />
                )}
              </div>
            </div>
          </div>
        </div>
        <Drawer
          placement="right"
          width={460}
          open={drawerOpen}
          destroyOnClose
          closable={false}
          onClose={() => setDrawerOpen(false)}
          title={
            <div className="d-flex align-items-center justify-content-between">
              <span className="fw-semibold">Add Employee Salary</span>
              <button
                type="button"
                className="btn p-0 text-dark"
                onClick={() => setDrawerOpen(false)}
              >
                ✕
              </button>
            </div>
          }
        >
          <div className="row mb-3">
            <div className="col-md-6">
              <label className="form-label">Branch</label>
              <Select
                showSearch
                placeholder="Select Branch"
                value={addBranchId}
                onChange={(val) => {
                  setAddBranchId(val);
                  setAddEmployeeId(null);
                }}
                options={addBranchesOptions}
                style={{ width: "100%" }}
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Department</label>
              <Select
                showSearch
                placeholder="Select Department"
                value={addDeptId}
                onChange={(val) => {
                  setAddDeptId(val);
                  setAddEmployeeId(null);
                }}
                options={addDeptOptions}
                style={{ width: "100%" }}
              />
            </div>
          </div>

          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Employee Name *</label>
              <Select
                showSearch
                placeholder="Select Employee"
                value={addEmployeeId}
                onChange={setAddEmployeeId}
                options={addEmpOptions}
                style={{ width: "100%" }}
                disabled={!addBranchId || !addDeptId}
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Effective Date *</label>
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select Effective Date"
                value={effectiveDate}
                onChange={(date) => setEffectiveDate(date)}
                format="DD-MM-YYYY"
                disabledDate={(current) =>
                  current && current < dayjs().startOf("day")
                }
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Monthly Salary *</label>
              <input
                className="form-control"
                type="number"
                placeholder="Enter Amount"
                value={monthlyCTC}
                onChange={(e) => setMonthlyCTC(e.target.value)}
                min="1"
              />
            </div>

            <div className="col-md-6">
              <label className="form-label">Salary Group Master *</label>
              <Select
                showSearch
                placeholder="Select Salary Group"
                value={selectedSalaryGroup}
                onChange={setSelectedSalaryGroup}
                options={addSalaryGroupOptions}
                style={{ width: "100%" }}
                filterOption={(input, option) =>
                  option?.label?.toLowerCase().includes(input.toLowerCase())
                }
              />
            </div>
            <div className="col-12 d-flex justify-content-end gap-2 mt-4">
              <button
                className="btn btn-secondary"
                onClick={() => setDrawerOpen(false)}
                disabled={loadingSave}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={handleSaveCTC}
                disabled={loadingSave}
              >
                {loadingSave ? (
                  <>
                    <Spin size="small" /> Saving...
                  </>
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </Drawer>

        <CommonFooter />
        <ViewCTC viewObj={viewObj} />
        <EditCTC
          editObj={editObj}
          onCtcUpdated={fetchEmployeeData}
        />
      </div>
    </div>
  );
};

export default Employee_Anual_CTC;
